import { getFieldglassJobPosting } from 'api/admin/fieldglass/getFieldglassJobPosting'
import { listFieldglassShiftIssues } from 'api/admin/fieldglass/listFieldglassShiftIssues'

const fieldglassKey = ['fieldglass'] as const

export const fieldglassKeys = {
  all: fieldglassKey,
  companyGroups: () => [...fieldglassKey, 'companyGroups'] as const,
  shiftIssues: () => [...fieldglassKey, 'shiftIssues'] as const,
  shiftIssuesList: (params?: Parameters<typeof listFieldglassShiftIssues>[0]) =>
    [
      ...fieldglassKeys.shiftIssues(),
      params?.page,
      params?.pageSize,
      params?.daysAgo,
      params?.companyGroupIds,
      params?.issueTypes,
    ] as const,
  jobPosting: (params?: Parameters<typeof getFieldglassJobPosting>[0]) =>
    [...fieldglassKey, 'jobPosting', params?.jobPostingId] as const,
}
